import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Stack,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Getrequestcall } from "../../request/Getrequest";
import { GET_SURVEY_DATE_NEVER } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import SurveyQuizModal from "./SurveyQuizModal";
import { English } from "../../constant/EnglishFallback";
import { setSurveyLaterToday } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";

export default function SurveyModal({ open, onClose, setQuizModal }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  let currentUserId = loginData?.userInformation?.UserId;
  const [mayBeLater, setMayBeLater] = useState(false);
  const [mayBeLaterKey, setMayBeLaterKey] = useState(1);
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme?.breakpoints?.down("sm"));
  const [disableButton, setDisableButton] = useState(false);

  const {
    TEXT_LATER_TODAY = English?.Survey_Dashboard_Web?.TEXT_LATER_TODAY,
    TEXT_TOMMORROW = English?.Survey_Dashboard_Web?.TEXT_TOMMORROW,
    TEXT_NEXT_WEEK = English?.Survey_Dashboard_Web?.TEXT_NEXT_WEEK,
    TEXT_NEXT_MONTH = English?.Survey_Dashboard_Web?.TEXT_NEXT_MONTH,
    TEXT_NEVER = English?.Survey_Dashboard_Web?.TEXT_NEVER,
    TEXT_WOULD_YOU_LIKE_TO = English?.Survey_Dashboard_Web?.TEXT_WOULD_YOU_LIKE_TO,
    TEXT_WE_WOULD_LOVE_TO_HEAR_YOUR_FEEDBACK = English?.Survey_Dashboard_Web
      ?.TEXT_WE_WOULD_LOVE_TO_HEAR_YOUR_FEEDBACK,
    BUTTON_SURE = English?.Survey_Dashboard_Web?.BUTTON_SURE,
    BUTTON_NEVER = English?.Survey_Dashboard_Web?.BUTTON_NEVER,
    BUTTON_MAYBE_LATER = English?.Survey_Dashboard_Web?.BUTTON_MAYBE_LATER,
    BUTTON_SAVE = English?.Survey_Dashboard_Web?.BUTTON_SAVE
  } = multiLanguageData?.Survey_Dashboard_Web || {};

  const handleSureModel = () => {
    setQuizModal(true);
    onClose();
  };

  const handleNever = async () => {
    setDisableButton(true);
    const response = await Getrequestcall(
      `${GET_SURVEY_DATE_NEVER}/${currentUserId}/5`,
      loginData?.accessToken
    );
    if (response?.status === 200) {
      onClose();
    }
    setDisableButton(false);
  };

  const MayBeLater = () => {
    setMayBeLater(true);
  };

  const handleSelectChange = (e) => {
    setMayBeLaterKey(e.target.value);
  };

  const handleNeverClose = () => {
    setMayBeLater(false);
  };

  const handleSave = async () => {
    setDisableButton(true);
    try {
      if (mayBeLaterKey == 1) {
        dispatch(setSurveyLaterToday(true));
      }
      const response = await Getrequestcall(
        `${GET_SURVEY_DATE_NEVER}/${currentUserId}/${mayBeLaterKey}`,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        handleNeverClose();
        onClose();
      }
      return response;
    } catch (error) {
      console.log("handleSave-> Error When Getting User Survey Date List: " + error);
    } finally {
      setDisableButton(false);
    }
  };

  const nextTimeArray = [
    {
      key: 1,
      value: TEXT_LATER_TODAY
    },
    {
      key: 2,
      value: TEXT_TOMMORROW
    },
    {
      key: 3,
      value: TEXT_NEXT_WEEK
    },
    {
      key: 4,
      value: TEXT_NEXT_MONTH
    },
    {
      key: 5,
      value: TEXT_NEVER
    }
  ];

  return (
    <>
      <Modal open={open} closeAfterTransition>
        <Box className="user-modal-responsive" sx={{ width: "auto" }}>
          {mayBeLater && (
            <Stack spacing={3} direction={"row"}>
              <Stack sx={{ justifyContent: "flex-start" }}>
                <Typography>{TEXT_WOULD_YOU_LIKE_TO}</Typography>
                <Typography>{TEXT_WE_WOULD_LOVE_TO_HEAR_YOUR_FEEDBACK}</Typography>
              </Stack>

              <Stack>
                <IconButton sx={{ p: 0 }} onClick={handleNeverClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </Stack>
          )}

          <Box sx={{ textAlign: "center",  pt: 0 }} >
            {!mayBeLater ? (
              <>
                <Typography>{TEXT_WOULD_YOU_LIKE_TO}</Typography>
                <Typography>{TEXT_WE_WOULD_LOVE_TO_HEAR_YOUR_FEEDBACK}</Typography>
                <Stack
                  spacing={2}
                  direction={isMobile ? "column" : "row"}
                  sx={{ pt: 2,  justifyContent: "center" }}
                  >
                  <Button
                    variant="contained"
                    disabled={disableButton}
                    onClick={() => {
                      handleSureModel();
                    }}>
                    {BUTTON_SURE}
                  </Button>
                  <Button
                    variant="contained"
                    disabled={disableButton}
                    loading={disableButton}
                    onClick={handleNever}>
                    {BUTTON_NEVER}
                  </Button>
                  <Button variant="contained" disabled={disableButton} onClick={MayBeLater}>
                    {BUTTON_MAYBE_LATER}
                  </Button>
                </Stack>
              </>
            ) : (
              <>
                <Stack spacing={3} sx={{ marginTop: 2 }} direction={"row"}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    variant="outlined"
                    style={{
                      width: "100%"
                    }}
                    sx={{
                      "& .css-w76bbz-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "8px!important"
                      }
                    }}
                    value={mayBeLaterKey}
                    onChange={handleSelectChange}>
                    {nextTimeArray.map((item, index) => (
                      <MenuItem key={index} value={item?.key}>
                        {item?.value}
                      </MenuItem>
                    ))}
                  </Select>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleSave();
                    }}
                    disabled={disableButton}
                    loading={disableButton}>
                    {BUTTON_SAVE}
                  </Button>
                </Stack>
              </>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
}
